import React, { useMemo } from "react";

const ShareLogos = ({ name }) => {
  // Generate a unique base ID once per component render
  const uniqueId = useMemo(() => Date.now() + "-" + Math.random().toString(36).substr(2, 6), []);

  const gradientId = prefix => `${prefix}-gradient-${uniqueId}`;
  if (name === "FACEBOOK") {
    const gid = gradientId("fb");

    return (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
          fill={`url(#${gid})`}
        />
        <path
          d="M22.2152 32.7402V21.5946H25.9332L26.6382 16.987H22.2152V13.9908C22.2152 12.7319 22.8363 11.4981 24.817 11.4981H26.8312V7.5703C26.8312 7.5703 25.0016 7.25977 23.2643 7.25977C19.6218 7.25977 17.2383 9.46707 17.2383 13.462V16.9786H13.1846V21.5862H17.2383V32.7319H22.2236L22.2152 32.7402Z"
          fill="white"
        />
        <defs>
          <linearGradient
            id={gid}
            x1="5.85816"
            y1="5.85816"
            x2="34.1418"
            y2="34.1418"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#1677F1" />
            <stop offset="0.18" stopColor="#176EE9" />
            <stop offset="0.46" stopColor="#1D55D3" />
            <stop offset="0.82" stopColor="#252EB0" />
            <stop offset="1" stopColor="#2B189C" />
          </linearGradient>
        </defs>
      </svg>
    );
  } else if (name === "TWITTER") {
    const gid = gradientId("tw");
    return (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.95431 0 0 8.9543 0 20C0 31.0457 8.95431 40 20 40Z"
          fill={`url(#${gid})`}
        />
        <path
          d="M21.6948 18.5977L28.3251 10.8848H26.7557L20.9982 17.5822L16.399 10.8848H11.0947L18.0523 21.0065L11.0947 29.0887H12.6642L18.7489 22.022L23.6084 29.0887H28.9126L21.6948 18.5893V18.5977ZM19.5463 21.0988L18.8413 20.0916L13.2349 12.0681H15.652L20.1757 18.539L20.8807 19.5461L26.764 27.9641H24.3469L19.5463 21.0988Z"
          fill="white"
        />
        <defs>
          <linearGradient
            id={gid}
            x1="5.85816"
            y1="5.85816"
            x2="34.1418"
            y2="34.1418"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#23004A" />
            <stop offset="0.96" stopColor="#010003" />
            <stop offset="1" />
          </linearGradient>
        </defs>
      </svg>
    );
  } else if (name === "INSTAGRAM") {
    const gid = gradientId("inst");
    
    return (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.95431 0 0 8.9543 0 20C0 31.0457 8.95431 40 20 40Z"
          fill={`url(#${gid})`}
        />
        <path
          d="M25.5138 13.3105C24.8424 13.3105 24.2969 13.8561 24.2969 14.5275C24.2969 15.1989 24.8424 15.7445 25.5138 15.7445C26.1852 15.7445 26.7308 15.1989 26.7308 14.5275C26.7308 13.8561 26.1852 13.3105 25.5138 13.3105Z"
          fill="white"
        />
        <path
          d="M20.084 14.8711C17.2557 14.8711 14.9561 17.1707 14.9561 19.9991C14.9561 22.8275 17.2557 25.1271 20.084 25.1271C22.9124 25.1271 25.212 22.8275 25.212 19.9991C25.212 17.1707 22.9124 14.8711 20.084 14.8711ZM20.084 23.2807C18.2712 23.2807 16.8025 21.8035 16.8025 19.9991C16.8025 18.1946 18.2796 16.7175 20.084 16.7175C21.8885 16.7175 23.3656 18.1946 23.3656 19.9991C23.3656 21.8035 21.8885 23.2807 20.084 23.2807Z"
          fill="white"
        />
        <path
          d="M24.1552 30.4078H15.8464C12.3969 30.4078 9.59375 27.6047 9.59375 24.1552V15.8464C9.59375 12.3969 12.3969 9.59375 15.8464 9.59375H24.1552C27.6047 9.59375 30.4079 12.3969 30.4079 15.8464V24.1552C30.4079 27.6047 27.6047 30.4078 24.1552 30.4078ZM15.8464 11.5493C13.4796 11.5493 11.5493 13.4796 11.5493 15.8464V24.1552C11.5493 26.522 13.4796 28.4523 15.8464 28.4523H24.1552C26.522 28.4523 28.4523 26.522 28.4523 24.1552V15.8464C28.4523 13.4796 26.522 11.5493 24.1552 11.5493H15.8464Z"
          fill="white"
        />
        <defs>
          <linearGradient
            id={gid}
            x1="5.85816"
            y1="5.85816"
            x2="34.1418"
            y2="34.1418"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFE185" />
            <stop offset="0.21" stopColor="#FFBB36" />
            <stop offset="0.38" stopColor="#FF5176" />
            <stop offset="0.52" stopColor="#F63395" />
            <stop offset="0.74" stopColor="#A436D2" />
            <stop offset="1" stopColor="#5F4EED" />
          </linearGradient>
        </defs>
      </svg>
    );
  } else if (name === "WHATSAPP") {
    const gid = gradientId("wh");
    return (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z"
          fill={`url(#${gid})`}
        />
        <path
          d="M9.70117 30.324L11.1783 24.8015C10.339 23.2908 9.9026 21.5955 9.9026 19.875C9.9026 14.2518 14.4767 9.67773 20.0998 9.67773C25.723 9.67773 30.2971 14.2518 30.2971 19.875C30.2971 25.4981 25.723 30.0722 20.0998 30.0722C18.4129 30.0722 16.7427 29.6442 15.2488 28.8385L9.70117 30.324ZM15.5258 26.7654L15.8783 26.9753C17.1624 27.739 18.6227 28.1419 20.0998 28.1419C24.6571 28.1419 28.3667 24.4322 28.3667 19.875C28.3667 15.3177 24.6571 11.6081 20.0998 11.6081C15.5425 11.6081 11.8329 15.3177 11.8329 19.875C11.8329 21.3773 12.2526 22.8628 13.0415 24.1637L13.2597 24.5162L12.4372 27.5963L15.5426 26.7654H15.5258Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.8931 21.293C23.4735 21.0412 22.928 20.7642 22.4328 20.9656C22.0551 21.1167 21.8117 21.7126 21.5683 22.0147C21.4424 22.1742 21.2914 22.191 21.0983 22.1154C19.6716 21.5447 18.5805 20.5964 17.8 19.2871C17.6657 19.0857 17.6909 18.9262 17.8503 18.7332C18.0853 18.4562 18.3875 18.1373 18.4462 17.7596C18.5133 17.3819 18.3371 16.9455 18.1776 16.6098C17.9762 16.1817 17.758 15.5691 17.33 15.3257C16.9355 15.0991 16.4152 15.225 16.0627 15.5103C15.4584 16.0055 15.1646 16.7776 15.173 17.5498C15.173 17.768 15.1982 17.9862 15.2569 18.196C15.3828 18.6996 15.6094 19.178 15.878 19.6228C16.0794 19.9585 16.2893 20.2942 16.5243 20.6047C17.288 21.6371 18.2364 22.5351 19.3275 23.2149C19.873 23.5506 20.4689 23.8444 21.0815 24.0458C21.7697 24.2724 22.3824 24.5074 23.121 24.3647C23.8931 24.2136 24.6569 23.7353 24.9674 22.9883C25.0597 22.7701 25.1017 22.5183 25.0513 22.2833C24.9422 21.7965 24.296 21.5112 23.9015 21.2762L23.8931 21.293Z"
          fill="white"
        />
        <defs>
          <linearGradient
            id={gid}
            x1="5.85816"
            y1="5.85816"
            x2="34.1418"
            y2="34.1418"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#00FB73" />
            <stop offset="1" stopColor="#00B25B" />
          </linearGradient>
        </defs>
      </svg>
    );
  } else if (name === "TELEGRAM") {
    const gid = gradientId("tlg");
    
    return (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95429 0 0 8.95431 0 20C0 31.0457 8.95429 40 20 40Z"
          fill={`url(#${gid})`}
        />
        <path
          d="M8.53595 19.528C8.53595 19.528 18.5401 15.4239 22.0148 13.972C23.3408 13.3929 27.8562 11.5465 27.8562 11.5465C27.8562 11.5465 29.9376 10.7408 29.7613 12.7047C29.7026 13.5104 29.241 16.3472 28.7794 19.4105C28.0828 23.7496 27.3358 28.4915 27.3358 28.4915C27.3358 28.4915 27.2183 29.826 26.2363 30.0526C25.2544 30.2876 23.6346 29.2469 23.3408 29.0119C23.1058 28.8356 19.0018 26.2338 17.4995 24.9665C17.0966 24.6224 16.635 23.9258 17.5582 23.1117C19.6396 21.2066 22.1239 18.8314 23.6346 17.3291C24.3312 16.6325 25.0194 15.0127 22.1323 16.985C18.0282 19.8218 13.9745 22.4823 13.9745 22.4823C13.9745 22.4823 13.0513 23.0614 11.314 22.541C9.57666 22.0207 7.55401 21.3241 7.55401 21.3241C7.55401 21.3241 6.16919 20.4596 8.53595 19.528Z"
          fill="white"
        />
        <defs>
          <linearGradient
            id={gid}
            x1="5.85816"
            y1="5.85816"
            x2="34.1418"
            y2="34.1418"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2CB5E5" />
            <stop offset="0.65" stopColor="#6C6EF5" />
            <stop offset="1" stopColor="#9146FF" />
          </linearGradient>
        </defs>
      </svg>
    );
  }
};

export default ShareLogos;
